<template>
	<div class="stamp-participant-list">
		<ManagingSection
			header="당첨 조건 분류 정보"
			:columnCount="4"
			class="stamp-participant-list__managing-section"
		>
			<ManagingBox title="이벤트 정보">
				<span
					v-if="details"
					v-text="`${details.id}: ${details.title}`"
				/>
			</ManagingBox>
			<ManagingBox title="출석 횟수">
				<PeriodBox
					:fromValue="stampMin"
					:toValue="stampMax"
					mode="number"
					@change="
						inputData([
							{ key: 'stampMin', value: $event.from },
							{ key: 'stampMax', value: $event.to },
						])
					"
					@enter="searching"
				/>
			</ManagingBox>
			<ManagingBox title="대체 출석 수">
				<Selector
					v-model="stampReplaceCnt"
					:optionList="stampReplaceCntList"
				/>
			</ManagingBox>
			<ManagingBox title="댓글 작성">
				<Selector v-model="isComment" :optionList="isCommentList" />
			</ManagingBox>
		</ManagingSection>
		<ManagingSection
			header="회원 분류 정보"
			:columnCount="3"
			class="stamp-participant-list__managing-section"
		>
			<ManagingBox title="회원 검색어">
				<Selector
					v-model="registerSearchType"
					:optionList="registerSearchTypeList"
				/>
				<input
					v-model="registerSearch"
					type="text"
					@keyup.enter="searching"
				/>
			</ManagingBox>
			<ManagingBox title="성별">
				<Selector v-model="gender" :optionList="genderList" />
			</ManagingBox>
			<ManagingBox title="연령대">
				<PeriodBox
					:fromValue="ageMin"
					:toValue="ageMax"
					mode="number"
					@change="
						inputData([
							{ key: 'ageMin', value: $event.from },
							{ key: 'ageMax', value: $event.to },
						])
					"
				/>
			</ManagingBox>
			<ManagingBox title="등급">
				<CheckboxList
					v-model="grade"
					:checkboxList="gradeList"
					keyName="value"
					valueName="name"
					class="stamp-participant-list__grade-selector"
				/>
			</ManagingBox>
			<ManagingBox title="카테고리 등급">
				<CateSelector v-model="selectedCate" :level="2" />
				<CheckboxList
					v-model="categoryGradeList"
					:checkboxList="categoryGradeOptionList"
					keyName="value"
					valueName="name"
					:disabled="!selectedCate.cate2"
				/>
			</ManagingBox>
			<ManagingBox title="브랜드 등급">
				<BrandSelector
					ref="brandSelector"
					@change="brandTargetId = $event ? $event.idBrand : null"
				/>
				<CheckboxList
					v-model="brandGradeList"
					:checkboxList="categoryGradeOptionList"
					keyName="value"
					valueName="name"
					:disabled="!brandTargetId"
				/>
			</ManagingBox>
			<ManagingBox title="피부 타입">
				<CheckboxList
					v-model="skinType"
					:checkboxList="skinTypeList"
					keyName="value"
					valueName="name"
				/>
			</ManagingBox>
			<ManagingBox title="가입일" :horizontalMode="true">
				가입 후
				<InputText
					:propValue="createDateAfterNumber"
					mode="number"
					class="stamp-participant-list__join-date-item"
					@input="createDateAfterNumber = $event"
				/>
				<Selector
					v-model="createDateTypeCd"
					:optionList="createDateTypeCdList"
					class="stamp-participant-list__join-date-item"
				/>
				이상
			</ManagingBox>
			<ManagingBox title="휴대폰 인증">
				<Selector
					v-model="isCertification"
					:optionList="isCertificationList"
				/>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection
			header="회원 제외 기준"
			:columnCount="3"
			class="stamp-participant-list__section"
		>
			<ManagingBox title="당첨이력">
				<div class="stamp-participant-list__winner-history-wrapper">
					최근
					<InputText
						:propValue="eventCandidateAfterNumber"
						mode="number"
						class="stamp-participant-list__winner-history-date"
						@input="eventCandidateAfterNumber = $event"
					/>
					<Selector
						v-model="eventCandidateTypeCd"
						:optionList="eventCandidateTypeCdList"
						class="stamp-participant-list__winner-history-date-type"
					/>
					동안
				</div>
				<div class="stamp-participant-list__winner-history-wrapper">
					<Selector
						v-model="eventType"
						:optionList="eventTypeList"
						class="stamp-participant-list__winner-history-event-type"
					/>
					당첨이력
					<Selector
						v-model="eventPrizeType"
						:optionList="eventPrizeTypeList"
						class="stamp-participant-list__winner-history-event-result"
					/>
				</div>
			</ManagingBox>
			<ManagingBox title="출석체크">
				<div class="stamp-participant-list__stamp-history-wrapper">
					최근
					<InputText
						:propValue="stampDateAfterNumber"
						mode="number"
						class="stamp-participant-list__stamp-history-date"
						@input="stampDateAfterNumber = $event"
					/>
					<Selector
						v-model="stampDateTypeCd"
						:optionList="stampDateTypeCdList"
						class="stamp-participant-list__stamp-history-date-type"
					/>
					동안
				</div>
				<div class="stamp-participant-list__stamp-history-wrapper">
					출석체크
					<InputText
						:propValue="stampCount"
						mode="number"
						@input="stampCount = $event"
						class="stamp-participant-list__stamp-history-cnt"
					/>
					건 이상 당첨
				</div>
			</ManagingBox>
			<ManagingBox title="제외회원">
				<CheckboxList
					v-model="exceptMember"
					:checkboxList="exceptMemberList"
					keyName="value"
					valueName="name"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" v-text="'검색'" @click="searching" />
			<button
				class="btn-main blue bordered"
				v-text="'초기화'"
				@click="initializing"
			/>
		</div>
		<ManagingSection :isTable="true" :bodyScrollTable="true">
			<template slot="infoSection">
				<b class="section__info__left">
					당첨 조건 대상 검색 결과 {{ list.length | currency }}건
				</b>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						v-text="'CSV'"
						@click="$store.dispatch('stamp/csvDown')"
					/>
					<Selector
						:value="order"
						:optionList="orderList"
						class="section__info__items"
						@input="orderInput"
					/>
				</div>
			</template>
			<RegisterList
				slot="bodyScrollTable"
				ref="registerList"
				:list="list"
				:hasSelectOn="!!(details && details.select_on)"
				@changeCheckListLength="changeCheckListLength"
			/>
		</ManagingSection>
		<div class="btn-wrap-main stamp-participant-list__select-wrap">
			당첨그룹명
			<Selector
				:value="targetGroup"
				:optionList="targetGroupList"
				class="stamp-participant-list__condition-selector"
				@input="targetGroupInput"
			/>
			<div>
				<button
					:disabled="!checkListLength"
					class="btn"
					v-text="'선택회원추가'"
					@click="addWinner()"
				/>
				<div class="stamp-participant-list__br" />
				<div class="stamp-participant-list__random-select-wrap">
					<InputText
						:propValue="randomCnt"
						mode="number"
						nextLabel="명"
						@input="
							$store.commit('stamp/changeState', [
								{ key: 'randomCnt', value: $event },
							])
						"
					/>
					<button
						:disabled="!randomCnt"
						class="btn stamp-participant-list__random-select-btn"
						v-text="'랜덤추가'"
						@click="addWinner(true)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import random from 'lodash/random';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PeriodBox from '@/components/PeriodBox.vue';
	import Selector from '@/components/Selector.vue';
	import CheckboxList from '@/components/CheckboxList.vue';
	import CateSelector from '@/components/CateSelector.vue';
	import BrandSelector from '@/components/common/BrandSelector.vue';
	import InputText from '@/components/InputText.vue';
	import RegisterList from '@/components/stamp/winner/RegisterList.vue';

	export default {
		name: 'StampParticipantList',
		components: {
			ManagingSection,
			ManagingBox,
			PeriodBox,
			Selector,
			CheckboxList,
			CateSelector,
			BrandSelector,
			InputText,
			RegisterList,
		},
		data() {
			const stampReplaceCntList = [null, 5, 4, 3, 2, 1].map(item => ({
				value: item,
				name: item === null ? '전체' : item,
			}));
			const isCommentList = [
				{ value: null, name: '전체' },
				{ value: true, name: '작성' },
				{ value: false, name: '미작성' },
			];
			const registerSearchTypeList = [
				{ value: 'nickName', name: '닉네임' },
				{ value: 'idRegister', name: '회원번호' },
			];
			const genderList = this.$store.getters['getListAddNull'](
				'gender'
			).map(({ id, name }) => ({ value: id, name }));
			const gradeList = this.$store.state.filter.gradeList.map(
				({ id, name, color }) => ({ value: id, name, color })
			);
			const categoryGradeOptionList =
				this.$store.state.filter.reviewer_grade_list.map(
					({ value, label }) => ({ value, name: label })
				);
			const createDateTypeCdList = [
				{ value: 1, name: '일' },
				{ value: 2, name: '개월' },
				{ value: 3, name: '년' },
			];
			const isCertificationList = [
				{ value: undefined, name: '전체' },
				{ value: true, name: '인증' },
				{ value: false, name: '미인증' },
			];
			const eventCandidateTypeCdList = [
				{ value: 1, name: '개월' },
				{ value: 2, name: '년' },
			];
			const eventTypeList = this.$store.getters
				.getListAddNull('eventType')
				.map(({ id, name }) => ({ value: id, name }));
			const eventPrizeTypeList = [
				{ value: 1, name: '당첨' },
				{ value: 2, name: '미당첨' },
				{ value: 3, name: '당첨대기' },
			];

			return {
				id: this.$route.params.idStamp,
				stampMin: '',
				stampMax: '',
				stampReplaceCntList,
				stampReplaceCnt: stampReplaceCntList[0].value,
				isCommentList,
				isComment: isCommentList[0].value,
				registerSearchTypeList,
				registerSearchType: registerSearchTypeList[0].value,
				registerSearch: '',
				genderList,
				gender: genderList[0].value,
				ageMin: '',
				ageMax: '',
				gradeList,
				grade: [],
				selectedCate: { cate1: null, cate2: null },
				categoryGradeOptionList,
				categoryGradeList: [],
				brandTargetId: null,
				brandGradeList: [],
				skinTypeList: this.$store.state.filter.skinTypeList.map(
					({ id, name }) => ({ value: id, name })
				),
				skinType: [],
				createDateAfterNumber: '',
				createDateTypeCdList,
				createDateTypeCd: createDateTypeCdList[0].value,
				isCertificationList,
				isCertification: isCertificationList[0].value,
				eventCandidateAfterNumber: '',
				eventCandidateTypeCdList,
				eventCandidateTypeCd: eventCandidateTypeCdList[0].value,
				eventTypeList,
				eventType: eventTypeList[0].value,
				eventPrizeTypeList,
				eventPrizeType: eventPrizeTypeList[0].value,
				stampDateAfterNumber: '',
				stampDateTypeCdList: eventCandidateTypeCdList,
				stampDateTypeCd: eventCandidateTypeCdList[0].value,
				stampCount: '',
				exceptMemberList: [
					{ value: 'isBlack', name: '블랙리스트 제외' },
					{ value: 'isBlind', name: '블라인드 회원 제외' },
					{
						value: 'isCurrentMonthReviewBlind',
						name: '해당월 대체출석리뷰 블라인드 처리자 제외',
					},
				],
				exceptMember: [],
				order: null,
				checkListLength: 0,
			};
		},
		computed: {
			...mapState({
				details: state => state.stamp.details,
				targetGroupList: state => state.stamp.targetGroupList,
				targetGroup: state => state.stamp.targetGroup,
				conditionList: state => state.stamp.conditionList,
				randomCnt: state => state.stamp.randomCnt,
				orderList: state => state.stamp.orderList,
			}),
			...mapGetters({
				list: 'stamp/winnerCheckedParticipantList',
				leftWinnerCnt: 'stamp/leftWinnerCnt',
			}),
		},
		methods: {
			changeCheckListLength(v) {
				this.checkListLength = v || 0;
			},
			initCheck() {
				this.$refs.registerList.initCheck();
			},
			inputData(list) {
				list.forEach(({ key, value }) => {
					this[key] = value;
				});
			},
			getParams() {
				const params = {
					order: this.order,
				};
				if (this.stampMin) params.stampMin = this.stampMin;
				if (this.stampMax) params.stampMax = this.stampMax;
				if (typeof this.stampReplaceCnt === 'number')
					params.stampReplaceCnt = this.stampReplaceCnt;
				if (typeof this.isComment === 'boolean')
					params.isComment = this.isComment;
				if (this.registerSearch)
					params[this.registerSearchType] = this.registerSearch;
				if (typeof this.gender === 'number')
					params.gender = this.gender;
				if (this.ageMin) params.ageMin = this.ageMin;
				if (this.ageMax) params.ageMax = this.ageMax;
				if (this.grade.length) params.grade = this.grade.join(',');
				if (this.selectedCate.cate2 && this.categoryGradeList.length) {
					params.secondCategoryTargetId = this.selectedCate.cate2;
					params.categoryGradeList = this.categoryGradeList.join(',');
				}
				if (this.brandTargetId && this.brandGradeList.length) {
					params.brandTargetId = this.brandTargetId;
					params.brandGradeList = this.brandGradeList.join(',');
				}
				if (this.skinType.length)
					params.skinType = this.skinType.join(',');
				if (this.createDateAfterNumber) {
					params.createDateAfterNumber = this.createDateAfterNumber;
					params.createDateTypeCd = this.createDateTypeCd;
				}
				if (typeof this.isCertification === 'boolean') {
					params.isCertification = this.isCertification;
				}
				if (this.eventCandidateAfterNumber) {
					params.eventCandidateAfterNumber =
						this.eventCandidateAfterNumber;
					params.eventCandidateTypeCd = this.eventCandidateTypeCd;
					if (typeof this.eventType === 'number')
						params.eventType = this.eventType;
					params.eventPrizeType = this.eventPrizeType;
				}
				if (this.stampDateAfterNumber && this.stampCount) {
					params.stampDateAfterNumber = this.stampDateAfterNumber;
					params.stampDateTypeCd = this.stampDateTypeCd;
					params.stampCount = this.stampCount;
				}
				if (this.exceptMember.length) {
					this.exceptMember.forEach(key => {
						params[key] = true;
					});
				}
				return params;
			},
			async setParticipantList() {
				const params = this.getParams();
				await this.$store.dispatch('stamp/setParticipantList', params);
			},
			async searching() {
				this.$store.commit('toggleSpinner', true);
				await this.setParticipantList();
				this.$store.commit('toggleSpinner', false);
			},
			initializing() {
				this.stampMin = '';
				this.stampMax = '';
				this.stampReplaceCnt = this.stampReplaceCntList[0].value;
				this.isComment = this.isCommentList[0].value;
				this.registerSearchType = this.registerSearchTypeList[0].value;
				this.registerSearch = '';
				this.gender = this.genderList[0].value;
				this.ageMin = '';
				this.ageMax = '';
				this.grade = [];
				this.selectedCate = { cate1: null, cate2: null };
				this.categoryGradeList = [];
				this.$refs.brandSelector.init();
				this.brandGradeList = [];
				this.skinType = [];
				this.createDateAfterNumber = '';
				this.createDateTypeCd = this.createDateTypeCdList[0].value;
				this.isCertification = this.isCertificationList[0].value;
				this.eventCandidateAfterNumber = '';
				this.eventCandidateTypeCd =
					this.eventCandidateTypeCdList[0].value;
				this.eventType = this.eventTypeList[0].value;
				this.eventPrizeType = this.eventPrizeTypeList[0].value;
				this.stampDateAfterNumber = '';
				this.stampDateTypeCd = this.stampDateTypeCdList[0].value;
				this.stampCount = '';
				this.exceptMember = [];
				this.memberListOrder = this.orderList[0].value;
				this.searching();
			},
			async orderInput(value) {
				this.order = value;
				this.searching();
			},
			async setBothWinnerList(func) {
				this.$store.commit('toggleSpinner', true);
				await Promise.all([
					this.$store.dispatch('stamp/setTargetGroupWinnerList'),
					this.$store.dispatch('stamp/setWinnerList'),
				]);
				func();
				this.$store.commit('toggleSpinner', false);
			},
			targetGroupInput(value) {
				this.$store.commit('stamp/changeState', [
					{ key: 'targetGroup', value },
					{ key: 'groupTab', value },
				]);
				this.setBothWinnerList(() => this.$emit('initCheck', 'winner'));
			},
			getRandomList(list, count) {
				const randomList = [];
				for (let i = 0; i < count; i++) {
					randomList.push(
						...list.splice(random(0, list.length - 1), 1)
					);
				}
				return randomList;
			},
			async addWinner(isRandom) {
				const groupId = this.targetGroup;
				const conditionItem = this.conditionList.find(
					item => item.id === groupId
				);
				const leftCount = this.leftWinnerCnt;
				const selectedList = isRandom
					? this.getRandomList(
							this.list
								.filter(item => !item.winner)
								.map(item => item.idRegister),
							this.randomCnt
						)
					: this.$refs.registerList.checkListModel;
				if (!selectedList.length) {
					alert('선택된 회원이 없습니다.');
					return;
				}
				const selectedLength = isRandom
					? selectedList.length
					: selectedList.length -
						selectedList.filter(
							id =>
								this.list.find(item => item.idRegister === id)
									.winner
						).length;
				if (selectedLength > leftCount) {
					alert(
						`인원이 초과되었습니다!\n[${conditionItem.title}]에는 ${leftCount}명만 더 추가할 수 있습니다.`
					);
					return;
				}
				try {
					this.$store.commit('toggleSpinner', true);
					await this.$axiosAdmin2NoSpinner.post(
						`/v3/api/stamp/${this.id}/winner-temporary`,
						{
							stamp_condition_id: groupId,
							register_ids: selectedList,
						}
					);
					this.setBothWinnerList(() => this.$emit('initCheck'));
				} catch (e) {
					console.error(e);
					alert('당첨자 선정 실패!');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
		created() {
			this.order = this.orderList[0].value;
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-participant-list {
		&::v-deep {
			.stamp-participant-list__managing-section .box__header {
				width: 100px;
				padding-left: 8px;
			}
		}

		&__grade-selector::v-deep {
			.list__item:nth-child(1) .check-box__text {
				color: green;
			}

			.list__item:nth-child(2) .check-box__text {
				color: orange;
			}

			.list__item:nth-child(3) .check-box__text {
				color: red;
			}

			.list__item:nth-child(4) .check-box__text {
				color: black;
			}
		}

		&__join-date-item {
			margin: 0 8px;
		}

		&__winner-history-wrapper,
		&__stamp-history-wrapper {
			display: flex;
			margin-top: 8px;
			align-items: center;

			&:first-child {
				margin-top: 0;
			}
		}

		&__winner-history-date {
			margin: 0 8px;
		}

		&__winner-history-date-type {
			margin-right: 8px;
		}

		&__winner-history-event-type {
			margin-right: 8px;
		}

		&__winner-history-event-result {
			margin-left: 8px;
		}

		&__stamp-history-date {
			margin: 0 8px;
		}

		&__stamp-history-date-type {
			margin-right: 8px;
		}

		&__stamp-history-cnt {
			margin: 0 8px;
		}

		&__select-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: left;
		}

		&__condition-selector {
			margin-left: 8px;
			margin-right: 16px;
		}

		&__br {
			position: relative;
			margin: 8px 0;
			text-align: center;

			&:before {
				content: '';
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				height: 1px;
				width: 100%;
				background-color: #000;
				margin: auto;
			}

			&:after {
				content: '또는';
				z-index: 1;
				position: relative;
				display: inline-block;
				background-color: #fff;
				padding: 0 4px;
			}
		}

		&__random-select-wrap {
			display: flex;
			align-items: center;
		}

		&__random-select-btn {
			margin-left: 8px;
		}
	}
</style>
